import React, { Component } from 'react';
import './SliderStyles.scss'
//import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from 'react-router-dom';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";



const SliderContainer = ({ containerObject, templateName, contentId, dataZone }) => {

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  }

  return (
    <>
      <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row mx-0 my-3 d-none  d-sm-flex ${containerObject.attributes.class ? containerObject.attributes.class : containerObject.attributes.articleContainerRendering ? containerObject.attributes.articleContainerRendering : ("col-md-12")}`} >
        <div className={`${containerObject.attributes.titleCSS}`} dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></div>
        <Carousel
          swipeable={true}
          draggable={true}
          showDots={false}
          responsive={responsive}
          ssr // means to render carousel on server-side.
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          keyBoardControl={true}
          //customTransition="all .5"
          //transitionDuration={500}
          //containerClass="carousel-container"
          removeArrowOnDeviceType={["tablet", "mobile"]}
          deviceType="desktop"
        // dotListClass="custom-dot-list-style"
        //itemClass="carousel-item-padding-40-px"
        >
          {containerObject.articles.map(slide => {
            return (
              <div key={slide.contentId} className="slider-item">
                {slide.attributes.mainImageUrl ?
                  <Link to={slide.attributes.mainImageUrl}>
                    <img fetchpriority="high" src={`${slide.mainImage ? slide.mainImage : ""}`} alt={slide.attributes.altText} />
                  </Link>
                  :
                  slide.mainImage ? <img fetchpriority="high" src={`${slide.mainImage}`} alt={slide.attributes.altText} /> : ""}
              </div>
            )
          })}

        </Carousel>
      </div>
    </>
  )
}

export default SliderContainer




// const SliderContainer = ({ containerObject, templateName, contentId, dataZone }) => {




//     const responsive = {
//         0: {
//             items: 1
//         },
//         450: {
//             items: 2
//         },
//         600: {
//             items: 3
//         },
//         1000: {
//             items: 5
//         }
//     }

//     return (
//         <>
//             <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row mx-0 my-3 ${containerObject.attributes.class ? containerObject.attributes.class : containerObject.attributes.articleContainerRendering ? containerObject.attributes.articleContainerRendering : ("col-md-12")}`} >
//                 <div className={`${containerObject.attributes.titleCSS}`} dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></div>
//                 <OwlCarousel className="owl-theme" responsive={responsive} nav={true} loop={containerObject.attributes.loop} autoplay={containerObject.attributes.autoplay} items={containerObject.attributes.items} dots={containerObject.attributes.dots === "false" ? false : true}>
//                     {containerObject.articles.map(slide => {
//                         return <div key={slide.contentId} className='item'>{slide.attributes.link && slide.title ? <Link to={slide.attributes.link} className={slide.attributes.class}></Link> : <div className={slide.attributes.class} dangerouslySetInnerHTML={{ __html: slide.title }}></div>}{slide.body ? <a href={slide.attributes.mainImageUrl}><img src={`${slide.mainImage}`} alt={slide.title} /></a> : slide.mainImage ? <img src={`${slide.mainImage}`} alt={slide.title} /> : ""}  </div>
//                     })}
//                 </OwlCarousel>
//             </div>
//         </>
//     )
// }

// export default SliderContainer
